import React, { useState, useEffect, useRef } from "react";
import styles from "./file_input.module.css";
import { useDispatch } from "react-redux";
import { SET_PORTAL_API } from "../../services/actions/portal_actions";
import { TITLE_ERROR } from "../../utils/constants";



// const FileInput = ({ label, onChange, name, extensions = ['pdf',], file = null }) => {

//   const [currentFile, setCurrentFile] = useState(file);
//   const [selectFileName, setSelectFileName] = useState(null);

//   const fileInput = useRef(null);

//   const MAXFILESIZE = 512 * 1024;

//   useEffect(() => {
//     // проверить на доступные расширения
//     const ext = file?.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase() || '';
//     console.log('ext =', ext);
//     // проверить на размер
//     if (file && (file !== currentFile) && (ext in extensions)) {
//       setCurrentFile(file)
//     }
//   }, [file]);

//   const getBase64 = (file) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = function () {
//       setCurrentFile(reader.result)
//       onChange(reader.result)
//     };
//     reader.onerror = function (error) {
//       console.log('Error: ', error);
//     }
//   }

//   return (
//     <div className={styles.container}>
//       <input
//         type='file'
//         id={`${name}`} name={`${name}`}
//         className={styles.fileInput}
//         ref={fileInput}
//         onChange={e => {
//           const file = e.target.files[0]
//           getBase64(file)
//           setSelectFileName(file.name);
//         }}
//       />
//       <button
//         onClick={() => {
//           fileInput.current.click()
//         }}
//         className={`button button__medium button__colorReverse`}
//         type='button'
//       >
//         {label}
//       </button>
//       {currentFile &&
//         <p className={styles.fileName}>
//           {selectFileName}&nbsp;
//           <button
//             className={styles.removeButton}
//             onClick={() => {
//               setCurrentFile(null);
//               setSelectFileName(null);
//             }}
//           >X</button>
//         </p>
//       }
//     </div>
//   )
// }

const FileInput = ({ label, name, extensions = ['pdf',], uploadThunk }) => {

  const [selectedFile, setSelectedFile] = useState(null);
  // const [base64File, setBase64File] = useState(null);
  const [isValid, setIsValid] = useState(false);

  const fileInput = useRef(null);

  const dispatch = useDispatch();


  // const getBase64 = (file) => {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = function () {
  //     setBase64File(reader.result);
  //   };
  //   reader.onerror = function (error) {
  //     console.log('Error: ', error);
  //   }
  // }


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && Object.keys(file) !== 0) {
      setSelectedFile(file);
      checkFileExtensionAndSize(file);
      // getBase64(file);
    } else return;
  };

  const checkFileExtensionAndSize = (file) => {
    const fileExtension = file?.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase() || '';
    const fileSize = file.size;

    const maxFileSize = 512 * 1024; // 512kB

    if (!extensions.includes(fileExtension)) {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: Object.values(
          `Расширение выбранного файла ${fileExtension} недопустимо.
          Допустимые расширения: ${extensions.join(', ')}.`
        )
      });
      setIsValid(false);
    } else if (fileSize > maxFileSize) {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: Object.values(
          `Размер выбранного файла ${fileSize} байт, что превышает максимальный размер в ${maxFileSize} байт.`
        )
      });
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  };


  const handleUpload = () => {
    if (!isValid) {
      dispatch({
        type: SET_PORTAL_API,
        title: TITLE_ERROR,
        text: Object.values(
          'Выберите файл, соответствующий условиям.'
        )
      });
      return;
    }

    // uploadThunk(base64File);
    uploadThunk(selectedFile);


  };

  return (
    <div className={styles.container}>
      <input
        id={`${name}`} name={`${name}`}
        className={styles.fileInput}
        ref={fileInput}
        type="file" onChange={handleFileChange}
      />

      <button
        onClick={() => {
          fileInput.current.click()
        }}
        className='button button__medium button__colorReverse'
        type='button'
      >{label}</button>
      <p className={styles.fileName}>
        {`${extensions.join(', ')}, до 512 kB`}
      </p>

      {selectedFile &&
        <>
          <div className={styles.fileInfoAction}>
            <p className={`${styles.fileName} ${!isValid && "red"}`}>
              {selectedFile.name}
            </p>
            <button
              className="button button__medium button__red__colorReverse"
              onClick={() => {
                setSelectedFile(null);
              }}
            >X</button>
          </div>
          <button
            onClick={handleUpload}
            className='button button__medium button__colorReverse'
          >
            Загрузить
          </button>
        </>
      }
    </div >
  );
};

export default FileInput;
